import React from 'react'
import FloatingLabel from './components/FloatingLabel'
import './index.scss'
import { InputFieldTypes, InputProps } from './types'
import DatePicker from './variations/Calendar/DatePicker'
import Multiselect from './variations/Multiselect'
import SelectInput from './variations/Select'
import TextInput from './variations/Text'

export default function Input(props: InputProps) {
  switch (props.type) {
    case InputFieldTypes.text:
      return (
        <div className="generic-input">
          <TextInput {...props}>
            {props.labelParams && <FloatingLabel {...props.labelParams} value={props.value}/>}
          </TextInput>
        </div>
      )

    case InputFieldTypes.select:
      return (
        <div className="generic-input">
          <SelectInput {...props}> 
            {props.labelParams && <FloatingLabel {...props.labelParams} value={props.value}/>}
          </SelectInput>
        </div>
      )
    
      case InputFieldTypes.datePicker:
        return (
          <div className="generic-input">
            <DatePicker {...props}/>
          </div>
        )

      case InputFieldTypes.multiselect:
        return (
          <div className="generic-input">
            <Multiselect {...props}/>
          </div>
        )
  }
}
